
<app-schedule-appointment
  [scheduleTypeId]="scheduleTypeId"
  [appointmentTypeId]="appointmentTypeId"
  (onSelectPeriod)="handleSelectPeriod($event)"
></app-schedule-appointment>

<!--<p-button label="back" (click)="goBack()"></p-button>-->

